import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import NotificationActions from '../../../../store/ducks/notifier';
import MaskedInput from 'react-text-mask'
// import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  TextField,
  Button,
  Grid,
  Typography,
  FormControl,
  CircularProgress,
  // Modal
}from '@material-ui/core';
// import { withStyles } from 'material-ui/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import withStyles from '@material-ui/core/styles/withStyles';
// import color from '../../../../styles/theme'
import api from '../../../../services/api'
import { Material } from './styles';
import eua from '../../../../assets/images/eua-flag.png';
import brazil from '../../../../assets/images/brazil-flag.png';
import esa from '../../../../assets/images/es-flag.png';
// import sicredi from '../../../../assets/images/logoEmpresas/logo-sicredi.svg';
import { lb_questionario } from '../../../../libs/labels';
import { lb_questionarioEn } from '../../../../libs/labelsEn';
import { lb_questionarioEs } from '../../../../libs/labelsEs';
import './home.css'
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  // KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import 'date-fns';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]}
      placeholderChar={'\u2000'}
    />
  );
}


TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class Home extends Component {
  state = {
    falhaApiKey: false,
    empresa: {},
    cargo: [],
    unidade: [],
    local:[],
    setor:[],
    ghe: '',
    turno: '',
    matricula: '',
    cargoSelec: null,
    unidadeSelec: null,
    localSelec: null,
    setorSelec: null,
    lang: this.props.lang,
    lb: {},
    modalTermo: false,
    inputCargo: '',
    listCargos: [],
    inputLocal: '',
    listLocal: [],
    inputUnid: '',
    listUnid: [],
    inputSetor: '',
    listSetor: [],
    dataNasa: {},
    selectedDate:null
  }

  fetchDados = async(type, apis) => {
    const {match} = this.props;
    const { lang } = this.state;
    this.setState({loading: true})
    try{
      if(type === 1){
        const {data} = await api.get('/quiz/', {params:{lang}}, {
          headers: { Authorization: match.params.apiKey }
        })
        // // console.log('data1', data) 
        this.setState({dataNasa:data})   
        // return data;
      }
      else{
        const {data} = await api.get('/quiz/', {params:{lang}}, {
          headers: { Authorization: apis }
        })
        // // console.log('data', data)
        this.setState({dataNasa:data})
        // return data;
      }
    }catch(err){
      console.log(err);
      return null;
    }
  }

  async componentWillMount() {
    const { lang, apiKey } = this.props;
    this.fetch(lang)
    // console.log('apiKey', apiKey)
    if(apiKey !== null && apiKey !== undefined && apiKey !== ''){
      try{
        const {data} = await api.get(`/quiz/${apiKey}`);
        this.fetchDados(0, data.apiKey);
      }catch(err){
        console.log(err)
      }
    }else{
      this.fetchDados(1)
    }
    this.dataAtualFormatada();
  }

  fetch = (lang) => {
    if(lang === 'pt_BR'){
      this.setState({lb: lb_questionario})
    }else if(lang === 'en'){
      this.setState({lb: lb_questionarioEn})
    }else if(lang === 'es'){
      this.setState({lb: lb_questionarioEs})
    }
    this.fetchEmpresa();
    // this.detectCam();
  }

  componentDidUpdate(prevProps, prevState) {
    const { lang } = this.props;
    const { inputCargo, inputLocal, inputSetor, cargo, local, setor } = this.state;

    if(prevProps.lang !== lang && lang !== ''){
      if(lang === 'pt_BR'){
        this.setState({lb: lb_questionario})
      }else if(lang === 'en'){
        this.setState({lb: lb_questionarioEn})
      }else if(lang === 'es'){
        this.setState({lb: lb_questionarioEs})
      }
      this.fetchEmpresa();
    }

    if (inputCargo === '' && inputCargo !== prevState.inputCargo) {
      this.setState({listCargos: cargo});
    }else if(inputCargo !== prevState.inputCargo) {
      this.filterCargos()
    }

    // if (inputUnid === '' && inputUnid !== prevState.inputUnid) {
    //   this.setState({listUnid: unidade});
    // }else if(inputUnid !== prevState.inputUnid) {
    //   this.filterUnidade()
    // }

    if (inputLocal === '' && inputLocal !== prevState.inputLocal) {
      this.setState({listLocal: local});
    }else if(inputLocal !== prevState.inputLocal) {
      this.filterLocal()
    }

    if (inputSetor === '' && inputSetor !== prevState.inputSetor) {
      this.setState({listSetor: setor});
    }else if(inputSetor !== prevState.inputSetor) {
      this.filterSetor()
    }
  }

  filterCargos = () => {
    const { cargo, inputCargo } = this.state
    const rawList = cargo.filter(item => {
      const valorMinusculo = inputCargo.toLowerCase()
      const cidadeMinusculo = item.descricao.toLowerCase()
      if(cidadeMinusculo.includes(valorMinusculo)){
        return item
      }
      return null;
    })
      this.setState({listCargos: rawList})
  }

  filterUnidade = () => {
    const { unidade, inputUnid } = this.state
    const rawList = unidade.filter(item => {
      const valorMinusculo = inputUnid.toLowerCase()
      const cidadeMinusculo = item.descricao.toLowerCase()
      if(cidadeMinusculo.includes(valorMinusculo)){
        return item
      }
      return null;
    })
    this.setState({listUnid: rawList})
  }

  filterLocal = () => {
    const { local, inputLocal } = this.state
    const rawList = local.filter(item => {
      const valorMinusculo = inputLocal.toLowerCase()
      const cidadeMinusculo = item.descricao.toLowerCase()
      if(cidadeMinusculo.includes(valorMinusculo)){
        return item
      }
      return null;
    })
    this.setState({listLocal: rawList})
  }

  filterSetor = () => {
    const { setor, inputSetor } = this.state
    const rawList = setor.filter(item => {
      const valorMinusculo = inputSetor.toLowerCase()
      const cidadeMinusculo = item.descricao.toLowerCase()
      if(cidadeMinusculo.includes(valorMinusculo)){
        return item
      }
      return null;
    })
    this.setState({listSetor: rawList})
  }

  fetchEmpresa = async() => {
    const { match, lang } = this.props;

    this.setState({falhaApiKey: true})
    try{
      const {data} = await api.get(`/cliente/${match.params.apiKey}`, {params: {lang}});
      const empresa = {nome: data.nomeOuRazao, cod: data.codigo, logo: data.logo};
      await this.setState({empresa});
      this.fetchCargo();
      // this.fetchUnidade();
      this.fetchLocal();
      this.fetchSetor();
      this.setState({falhaApiKey: false})
    }catch(err){
      console.log(err)
      this.setState({falhaApiKey: true});
    }
  }

  fetchCargo = async() => {
    const { lang } = this.props;
    const {empresa} = this.state;
    try{
      const {data} = await api.get(`/controller/cargo/?cliente=${empresa.cod}`, {params:{lang}})
      this.setState({cargo: data})
      this.setState({listCargos: data})
      // // console.log(data)
    }catch(err){
      console.log(err)
    }
  }

  cpfExists = async(cpf) => {
    const {lb} = this.state;
    const { lang, notify } = this.props;
    try{
      const {data} = await api.get(`/homequestionario/cpf/${cpf}/lang/${lang}`)
      // // console.log(data);
      if(data.error) {
        notify(data.message, { variant: 'error' });
        return true;
      } else {
        return false;
      }
    }catch(err){
      console.log(err)
      notify(lb["notify.cpf"], { variant: 'error' });
      return true;
    }
  }

  fetchUnidade = async() => {
    const { lang } = this.props;
    const {empresa} = this.state;
    try{
      const {data} = await api.get(`/controller/unidade/?cliente=${empresa.cod}`, {params:{lang}})
      this.setState({unidade: data})
      this.setState({listUnid:data})
    }catch(err){
      console.log(err)
    }
  }

  fetchLocal = async() => {
    const { lang } = this.props;
    const {empresa} = this.state;
    try{
      const {data} = await api.get(`/controller/local/?cliente=${empresa.cod}`, {params:{lang}})
      this.setState({local: data})
      this.setState({listLocal:data})
    }catch(err){
      console.log(err)
    }
  }

  fetchSetor = async() => {
    const { lang } = this.props;
    const {empresa} = this.state;
    try{
      const {data} = await api.get(`/controller/setor/?cliente=${empresa.cod}`, {params:{lang}})
      this.setState({setor: data})
      this.setState({listSetor:data})
    }catch(err){
      console.log(err)
    }
  }

  detectCam = () => {
    const {notify, lang} = this.props;
    const lbNotify = lang === 'pt_BR'? lb_questionario : lang === 'en' ? lb_questionarioEn : lb_questionarioEs
    notify(lbNotify["notify.alertaCam"], { variant: 'error' });
    if(navigator && navigator.mediaDevices)  {
      navigator.mediaDevices.getUserMedia({video: true, audio: false})
        .then(function(stream) {
          stream.getTracks().forEach(track => track.stop());
        }).catch(function(err) {
          // console.log("error: " + err);
          notify(lbNotify["notify.semCam"], { variant: 'error' });
        });
    }
  }

  dataAtualFormatada(){
      // var data = new Date(),
      //     dia  = data.getDate().toString(),
      //     diaF = (dia.length === 1) ? '0'+dia : dia,
      //     mes  = (data.getMonth()+1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      //     mesF = (mes.length === 1) ? '0'+mes : mes,
      //     anoF = data.getFullYear();
      // var dataFormatada =  diaF+"/"+mesF+"/"+anoF;
      this.setState({selectedDate: new Date()})
  }

  handleSubmit = async(event) => {
    const {cargoSelec,
          //  unidadeSelec, 
           localSelec, 
           setorSelec, 
           dataNasa,
           selectedDate,
           ghe, turno, //matricula, 
           lb//, 
          //  empresa
    } = this.state;
    const {notify} = this.props;

    if(cargoSelec === null
      // || unidadeSelec === null
      || localSelec === null
      || setorSelec === null){
      notify(lb["notify.erroSubmit"], { variant: 'error' });
      return
    }
    // if(ghe.trim() === ""){
    //   notify(lb["notify.erroSubmit"], { variant: 'error' });
    //   return
    // }

    // if(empresa.cod === 378 && !this.isValidCPF(matricula)) {
    //   notify(lb["notify.cpf"], { variant: 'error' });
    //   return
    // }

    // if(!this.isEmail(email)) {
    //   notify(lb["notify.email"], { variant: 'error' });
    //   return
    // }

    // if(empresa.cod === 378) {
    //   let cpfExists = await this.cpfExists(matricula);
    //   // // console.log(cpfExists);
    //   if(cpfExists) {
    //     return
    //   }
    // }

    this.fetchDados(1);
    // // console.log('fechDados', dataNasa)
    return this.props.next({cargoSelec, 
        // unidadeSelec, 
        localSelec, 
        setorSelec, dataNasa,
        ghe, 
        turno, 
        selectedDate
        // matricula
      })
  }

  changeCargo = value => {
    this.setState({inputCargo: value.target.value})
  }

  changeUnidade = value => {
    this.setState({inputUnid: value.target.value})
  }

  changeLocal = value => {
    this.setState({inputLocal: value.target.value})
  }

  changeSetor = value => {
    this.setState({inputSetor: value.target.value})
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  isEmail(email){

    let usuario = email.substring(0, email.indexOf("@"));
    let dominio = email.substring(email.indexOf("@")+ 1, email.length);

    if ((usuario.length >=1) &&
        (dominio.length >=3) &&
        (usuario.search("@")===-1) &&
        (dominio.search("@")===-1) &&
        (usuario.search(" ")===-1) &&
        (dominio.search(" ")===-1) &&
        (dominio.search(".")!==-1) &&
        (dominio.indexOf(".") >=1)&&
        (dominio.lastIndexOf(".") < dominio.length - 1)) {
        return true;
    } else {
        return false
    }

  }

  handleDateChange = (date) => {
    this.setState({selectedDate: date})
  }


  isValidCPF(cpf) {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '')
    if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
    ) {
        return false
    }



    var soma = 0
    var resto
    for (var i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
    resto = (soma * 10) % 11


    if ((resto === 10) || (resto === 11))  resto = 0

    if (resto !== parseInt(cpf.substring(9, 10)) ) return false



    soma = 0
    for (var j = 1; j <= 10; j++) {
      soma = soma + parseInt(cpf.substring(j-1, j)) * (12 - j)
    };

    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11))  resto = 0
    if (resto !== parseInt(cpf.substring(10, 11) ) ) return false
    return true
  }

  render() {
      const {
        falhaApiKey,
        empresa,
        // ghe,
        turno,
        // matricula,
        lb,
        // modalTermo,
        listCargos,
        // listUnid,
        listLocal,
        listSetor,
        selectedDate,
      } = this.state;
      const {
        classes,
        handleSetLinguage
      } = this.props;
    return (
      <Grid container>
        <Grid item style={{width: '100%', margin: '20px 0px'}}>
          <Grid item style={{width: '100%', display: 'flex'}}>
            <Grid item style={{width: '87%'}}>
              {/*eslint-disable-next-line*/}
              {(empresa.logo != null && empresa.logo != '') ? <img  style={{width: '157.15px', height: '60.05px', cursor: 'pointer'}} src={require(`../../../../assets/images/logoEmpresas/${empresa.logo}`)} /> : <div></div>}
              <Typography className={classes.subTitle}>
                {lb["home.text1"]}
              </Typography>
              <Typography style={{marginTop: '15px', marginBottom: '8px'}}>
                {lb["home.text2"]}
              </Typography>
            </Grid>
            <Grid style={{display: 'flex', flexDirection: 'row', width: '13%', justifyContent: 'flex-end', alignItems: 'flex-start'}}>
              <Grid style={{display: 'flex', alignItems: 'center', marginRight: '5px'}} onClick={() => handleSetLinguage('pt_BR')}>
                {/*eslint-disable-next-line*/}
                <img src={brazil} style={{width: '20px', height: '20px', cursor: 'pointer'}}/>
              </Grid>
              <Grid style={{display: 'flex', alignItems: 'center', marginRight:'2px'}} onClick={() => handleSetLinguage('en')}>
                {/*eslint-disable-next-line*/}
                <img src={eua} style={{width: '20px', height: '20px', cursor: 'pointer'}}/>
              </Grid>
              <Grid style={{background: 'none', border: 'none', outline: 'none', display: 'flex', alignItems: 'center', marginTop: '-2.5px'}} onClick={() => handleSetLinguage('es')}>
                {/*eslint-disable-next-line*/}
                <img src={esa} style={{width: '25px', height: '25px', cursor: 'pointer'}}/>
              </Grid>
            </Grid>
          </Grid>
          <Typography className={classes.empresaNome}>
            {empresa.nome}
          </Typography>
      {/* {// console.log(dataAtual)}
          <TextField
            id="date"
            label="Data Registro"
            type="date"
            defaultValue={dataAtual}
            className={classes.textFieldData}
            InputLabelProps={{
              shrink: true,
            }}
          /> */}

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                className={classes.textFieldData}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Data Registro"
                value={selectedDate}
                onChange={this.handleDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>

          {/* <TextField
            label={lb["label.ghe"]}
            className={classes.textfield}
            name="ghe"
            id="ghe"
            value={ghe}
            onChange={value => this.setState({ghe: value.target.value})}
            variant="outlined"
            type="email"
            fullWidth
          /> */}
          {/* <TextField
            label={lb["label.email"]}
            className={classes.textfield}
            name="email"
            id="email"
            value={email}
            onChange={value => this.setState({email: value.target.value})}
            variant="outlined"
            type="email"
            fullWidth
          /> */}
          {/* {
            empresa.cod === 378 ?
            <TextField
            label={lb["label.matriculacpf"]}
            className={classes.textfield}
            name="matricula"
            id="formatted-text-mask-input"
            value={matricula}
            onChange={this.handleChange('matricula')}
            variant="outlined"
            fullWidth

            InputProps={{
              inputComponent: TextMaskCustom
            }}
          />
           :
            <TextField
            label={lb["label.matricula"]}
            className={classes.textfield}
            name="matricula"
            id="matricula"
            value={matricula}
            onChange={value => this.setState({matricula: value.target.value})}
            variant="outlined"
            type="email"
            fullWidth
          />
          } */}
          {/* <FormControl className={classes.formControl} fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              onChange={ (value, option) => this.setState({unidadeSelec: option === null ? '' : option.id}) }
              options={listUnid}
              getOptionLabel={option => (option.descricao === null ? '' : option.descricao)}
              renderInput={unidadeSelec => (
                <TextField {...unidadeSelec} label={lb["label.unidade"]} variant="outlined" fullWidth onChange={this.changeUnidade}/>
              )}
              noOptionsText={lb["label.digite"]}
            />
          </FormControl> */}

         
          <FormControl className={classes.formControl} fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo-8"
              onChange={ (value, option) => this.setState({setorSelec: option === null ? '' : option.id}) }
              options={listSetor}
              getOptionLabel={option => (option.descricao === null ? '' : option.descricao)}
              renderInput={setorSelec => (
                <TextField {...setorSelec} label={lb["label.setor"]} variant="outlined" fullWidth onChange={this.changeSetor}/>
              )}
              noOptionsText={lb["label.digite"]}
            />
          </FormControl>
          <FormControl className={classes.formControl} fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo-9"
              onChange={ (value, option) => this.setState({localSelec: option === null ? '' : option.id}) }
              options={listLocal}
              getOptionLabel={option => (option.descricao === null ? '' : option.descricao)}
              renderInput={localSelec => (
                <TextField {...localSelec} label={lb["label.localTrabalho"]} variant="outlined" fullWidth onChange={this.changeLocal}/>
              )}
              noOptionsText={lb["label.digite"]}
            />
          </FormControl>
          <FormControl className={classes.formControl} fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo-10"
              onChange={ (value, option) => this.setState({cargoSelec:  option === null ? '' : option.id}) }
              options={listCargos}
              getOptionLabel={option => (option.descricao === null ? '' : option.descricao)}
              renderInput={cargoSelec => (
                <TextField {...cargoSelec} label={lb["label.cargo"]} variant="outlined" fullWidth onChange={this.changeCargo}/>
              )}
              noOptionsText={lb["label.digite"]}
            />
          </FormControl>
          <TextField
            label={lb["label.turno"]}
            className={classes.textfield}
            name="turno"
            id="turno"
            value={turno}
            onChange={value => this.setState({turno: value.target.value})}
            variant="outlined"
            type="email"
            fullWidth
          />
          {/* <Grid style={{margin: '5px'}}>
            <Typography>
              {lb["home.termoClick"]}
              (<b style={{cursor: 'pointer'}} onClick={() => this.setState({modalTermo: true})}>{lb["home.click"]}</b>)
            </Typography>
          </Grid> */}
          <Button
            fullWidth
            disabled={falhaApiKey}
            variant="contained"
            color="secondary"
            style={{color: '#fff'}}
            onClick={() => this.handleSubmit()}
          >
            {falhaApiKey?
              <CircularProgress size={25} /> : lb["button.continuar"]
            }
          </Button>
        </Grid>
        {/* <Modal
          open={modalTermo}
          className='termo'
          onClose={() => this.setState({modalTermo: false})}
        >
          <Grid style={{backgroundColor: "#fff", width: '50%', height: '65%', outline: 'none', padding: '20px', overflowX: 'auto'}}>
            <Typography className='termo-font'>
              <b>{lb["home.termo1"]}</b>
              <br/>
              {lb["home.termo2"]}
              <br/>
              {lb["home.termo3"]}
              <br/>
              {lb["home.termo4"]}
              <br/>
              {lb["home.termo5"]}
              <br/>
              {lb["home.termo6"]}
              <br/>
              <br/>
              <b>{lb["home.termo7"]}</b>
              <br/>
              {lb["home.termo8"]}
              <br/>
              {lb["home.termo9"]}
              <br/>
              {lb["home.termo10"]}
              <br/>
              {lb["home.termo11"]}
            </Typography>
          </Grid>
        </Modal> */}
      </Grid>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  notify: (message, options) => dispatch(NotificationActions.notify(message, options)),
});

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  connect(null, mapDispatchToProps),
  withStyles(Material, { withTheme: true }),
)(Home);

